"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Loader_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Loader"));
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("../../../../theme/styled-components"));
var utilities_1 = require("../../../../utilities/utilities");
var DefaultComment_1 = tslib_1.__importDefault(require("./DefaultComment"));
var Video = styled_components_1["default"].video(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: block;\n"], ["\n  display: block;\n"])));
var GfyMultimedia = function (_a) {
    var _b, _c;
    var comment = _a.comment;
    var _d = comment.message, message = _d === void 0 ? '' : _d;
    var _e = react_1["default"].useState(), gfyData = _e[0], setGfyData = _e[1];
    var _f = react_1["default"].useState(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = react_1["default"].useState(), error = _g[0], setError = _g[1];
    react_1["default"].useEffect(function () {
        if (!message.includes('gfyitem')) {
            return;
        }
        setIsLoading(true);
        var match = message.match(/data-id="(.+)"/);
        if (match && match[1]) {
            var dataId = match[1];
            fetch("https://api.gfycat.com/v1/gfycats/" + dataId)
                .then(function (res) {
                if (!res.ok || res.status !== 200) {
                    setError({ status: res.status });
                }
                return res.json();
            })
                .then(function (data) {
                var _a;
                // Data spracujem, len ak mi pride MP4. Inak predpokladam nespravne data z API a renderujem
                // `DefaultComment` (uvidime ako sa to osvedci)
                setGfyData((data === null || data === void 0 ? void 0 : data.gfyItem.content_urls) && ((_a = data === null || data === void 0 ? void 0 : data.gfyItem.content_urls) === null || _a === void 0 ? void 0 : _a.mp4)
                    ? data
                    : null);
                setIsLoading(false);
            })["catch"](function (err) {
                setError({ status: 500 });
                console.error(err);
                setIsLoading(false);
            });
        }
    }, [message]);
    var gfyItem = gfyData === null || gfyData === void 0 ? void 0 : gfyData.gfyItem;
    return isLoading ? (react_1["default"].createElement(Loader_1["default"], { size: "s" })) : error ? (react_1["default"].createElement(react_1["default"].Fragment, null,
        utilities_1.__('Chyba pri načítaní dát z gfycat!'),
        "\u00A0(status=",
        error.status,
        ")")) : gfyItem && ((_b = gfyItem.content_urls) === null || _b === void 0 ? void 0 : _b.mp4) ? (react_1["default"].createElement(Video, { controls: true, poster: gfyItem.posterUrl, width: (_c = gfyItem.content_urls) === null || _c === void 0 ? void 0 : _c.mp4.width, height: "auto" },
        gfyItem.content_urls.mp4 && (react_1["default"].createElement("source", { src: gfyItem.content_urls.mp4.url, type: "video/mp4" })),
        gfyItem.content_urls.webm && (react_1["default"].createElement("source", { src: gfyItem.content_urls.webm.url, type: "video/webm" })),
        gfyItem.content_urls.webp && (react_1["default"].createElement("source", { src: gfyItem.content_urls.webp.url, type: "video/web" })),
        "Sorry, your browser doesn't support embedded videos, but don't worry, you can",
        react_1["default"].createElement("a", { href: gfyItem.content_urls.mp4.url }, "download the MP4"),
        "and watch it with your favorite video player!")) : (react_1["default"].createElement(DefaultComment_1["default"], { comment: comment }));
};
exports["default"] = react_1["default"].memo(GfyMultimedia);
var templateObject_1;
